export const MAX_REFERENCE_BYTES = 10 * 1024 * 1024;
export function inspectImage(bytes) {
  const b=bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes);
  const v=new DataView(b.buffer,b.byteOffset,b.byteLength);
  const ascii=(offset,length)=>String.fromCharCode(...b.slice(offset,offset+length));
  let type,width,height;
  if(b.length>=33 && b[0]===137 && ascii(1,7)==='PNG\r\n\x1a\n' && ascii(12,4)==='IHDR') {
    type='image/png';width=v.getUint32(16);height=v.getUint32(20);
  } else if(b.length>=30 && ascii(0,4)==='RIFF' && ascii(8,4)==='WEBP') {
    type='image/webp';const chunk=ascii(12,4);
    const u24=o=>b[o]|(b[o+1]<<8)|(b[o+2]<<16);
    if(chunk==='VP8X'){width=u24(24)+1;height=u24(27)+1;}
    else if(chunk==='VP8 ' && b[23]===157 && b[24]===1 && b[25]===42){width=v.getUint16(26,true)&16383;height=v.getUint16(28,true)&16383;}
    else if(chunk==='VP8L' && b[20]===47){const bits=v.getUint32(21,true);width=(bits&16383)+1;height=((bits>>>14)&16383)+1;}
  } else if(b.length>=4 && b[0]===255 && b[1]===216) {
    type='image/jpeg';let i=2;
    while(i+4<=b.length){if(b[i++]!==255)break;while(b[i]===255)i++;const marker=b[i++];if(marker===217||marker===218)break;const len=v.getUint16(i);if(len<2||i+len>b.length)break;
      if([192,193,194,195,197,198,199,201,202,203,205,206,207].includes(marker) && len>=8){height=v.getUint16(i+3);width=v.getUint16(i+5);break;}i+=len;
    }
  }
  if(!type||!width||!height||width>16384||height>16384||width*height>40000000) throw new Error('Invalid PNG, JPEG or WebP image, or image exceeds 40 megapixels.');
  return {type,width,height};
}
